import Vue from 'vue';
import store from '@/store';
import permissions from '../../common/constants/permissions';

export const freeRoutes = [
  { name: 'Ui' },
  { name: 'PillarForm' },
  { name: 'Sso' },
  { name: '404' },
  { name: 'Faq' },
  { name: 'Epic' },
  { name: 'Login' },
  { name: 'UiIcons' },
  { name: 'Invitee' },
  { name: 'Register' },
  { name: 'Confirmation' },
  { name: 'PrivacyPolicy' },
  { name: 'ForgotPassword' },
  { name: 'ConfirmPassword' },
  { name: 'CheckEligibility' },
  { name: 'TermsAndConditions' },
  { name: 'InviteeConfirmation' },
];

export const availableRoutes = {
  PATIENT: [
    { name: 'Dashboard' },
    { name: 'Booking' },
    { name: 'Services' },
    { name: 'SuperBill' },
    { name: 'Appointments' },
    { name: 'Messenger' },
    { name: 'VideoCall' },
    { name: 'MyProfile' },
    { name: 'WaitingRoom' },
    { name: 'PatientRecords' },
    { name: 'PatientRecordsMeasurement' },
    { name: 'PatientRecordsLog' },
    { name: 'PatientProfile' },
    { name: 'RpmPatientProfile' },
  ],
  PROVIDER: [
    { name: 'Dashboard' },
    { name: 'Appointments' },
    { name: 'Schedule' },
    { name: 'Messenger' },
    { name: 'VideoCall' },
    { name: 'MyProfile' },
    { name: 'WaitingRoom' },
    { name: 'PatientProfile' },
  ],
  CLINIC_ADMIN: [
    { name: 'VideoCall' },
    { name: 'WaitingRoom' },
    { name: 'Booking' },
    { name: 'Dashboard' },
    { name: 'Metrics' },
    { name: 'Schedule' },
    { name: 'Patients' },
    { name: 'Providers' },
    { name: 'Clinics' },
    { name: 'Messenger' },
    { name: 'ReportGenerator' },
    { name: 'Inventory' },
    { name: 'Enrollment' },
    { name: 'Orders' },
    { name: 'Monitoring' },
    { name: 'ClinicProfile' },
    { name: 'ProviderProfile' },
    { name: 'ScheduleCA' },
    { name: 'EditClinic' },
    { name: 'EditProvider' },
    { name: 'EditPatient' },
    { name: 'CreatePatient' },
    { name: 'CreateProvider' },
    { name: 'PatientProfile' },
    { name: 'EnrollmentDetail' },
    { name: 'RpmPatientProfile' },
    { name: 'DataImport' },
    { name: 'DataImportUploadCSV' },
    { name: 'DataImportFixErrors' },
    { name: 'Settings' },
    { name: 'Support' },
  ],
  SUPER_ADMIN: [
    { name: 'Dashboard' },
    { name: 'SuperAdmins' },
    { name: 'ClinicAdmins' },
    { name: 'Patients' },
    { name: 'Providers' },
    { name: 'Clinics' },
    { name: 'ReportGenerator' },
    { name: 'SftpFtpUsers' },
    { name: 'CreateSuperAdmin' },
    { name: 'EditSuperAdmin' },
    { name: 'CreateClinicAdmin' },
    { name: 'EditClinicAdmin' },
    { name: 'CreateProvider' },
    { name: 'EditProvider' },
    { name: 'CreatePatient' },
    { name: 'CreateClinic' },
    { name: 'EditClinic' },
    { name: 'EditPatient' },
    { name: 'SftpFtpUsers' },
    { name: 'Settings' },
    { name: 'ReportPatient' },
  ],
};

const sidebarLinks = [
  {
    title: 'sidebar.home',
    route: 'Dashboard',
    icon: '$home',
    roles: ['SUPER_ADMIN', 'PROVIDER', 'PATIENT'],
  },
  {
    title: 'sidebar.appointments',
    route: 'Dashboard',
    icon: '$home',
    roles: ['CLINIC_ADMIN'],
    permission: {
      name: 'VIEW_APPOINTMENTS',
      role: 'CLINIC_ADMIN',
    },
  },
  {
    title: 'sidebar.services',
    route: 'Services',
    icon: '$information',
    roles: ['SUPER_ADMIN', 'PROVIDER', 'PATIENT'],
    additionalRules: {
      SERVICES: {
        iSMyGuardianDoc: true,
      },
    },
    children: [{
      title: 'sidebar.superBill',
      route: 'SuperBill',
      icon: '$coins',
      roles: ['SUPER_ADMIN', 'PROVIDER', 'PATIENT'],
    }],
  },
  {
    title: 'sidebar.appointments',
    route: 'Appointments',
    icon: '$appointments',
    roles: ['PATIENT', 'PROVIDER'],
  },
  {
    title: 'sidebar.metrics',
    route: 'Metrics',
    icon: '$metrics',
    roles: ['CLINIC_ADMIN'],
    permission: {
      name: 'VIEW_METRICS',
      role: 'CLINIC_ADMIN',
    },
  },
  {
    title: 'sidebar.schedule',
    route: 'Schedule',
    icon: '$schedule',
    roles: ['PROVIDER', 'CLINIC_ADMIN'],
    permission: {
      name: 'EDIT_SCHEDULE',
      role: 'CLINIC_ADMIN',
    },
  },
  {
    title: 'sidebar.booking',
    route: 'Booking',
    icon: '$plus',
    class: 'v-icon--circle',
    roles: ['PATIENT'],
    additionalRules: {
      PATIENT: {
        requireMyGuardianDocSubscription: true,
      },
    },
  },
  {
    title: 'sidebar.messages',
    route: 'Messenger',
    icon: '$message',
    noExact: true,
    roles: ['PATIENT', 'CLINIC_ADMIN', 'PROVIDER'],
    additionalRules: {
      PATIENT: {
        requireMyGuardianDocSubscription: true,
      },
    },
  },
  {
    title: 'sidebar.myProfile',
    route: 'MyProfile',
    icon: '$profile',
    class: 'v-icon--circle',
    roles: ['PATIENT', 'PROVIDER'],
  },
  {
    title: 'sidebar.superAdmins',
    route: 'SuperAdmins',
    icon: '$super-admin',
    roles: ['SUPER_ADMIN'],
  },
  {
    title: 'sidebar.clinicAdmins',
    route: 'ClinicAdmins',
    icon: '$clinic-admin',
    roles: ['SUPER_ADMIN'],
  },
  {
    title: 'sidebar.patients',
    route: 'Patients',
    icon: '$patient',
    roles: ['CLINIC_ADMIN', 'SUPER_ADMIN'],
    permission: {
      name: 'VIEW_PATIENTS',
      role: 'CLINIC_ADMIN',
    },
  },
  {
    title: 'sidebar.providers',
    route: 'Providers',
    icon: '$provider',
    roles: ['CLINIC_ADMIN', 'SUPER_ADMIN'],
    permission: {
      name: 'VIEW_PROVIDERS',
      role: 'CLINIC_ADMIN',
    },
  },
  {
    title: 'sidebar.clinics',
    route: 'Clinics',
    icon: '$clinic',
    roles: ['CLINIC_ADMIN', 'SUPER_ADMIN'],
    permission: {
      name: 'VIEW_CLINICS',
      role: 'CLINIC_ADMIN',
    },
  },
  {
    title: 'sidebar.reports',
    route: 'ReportGenerator',
    icon: '$note',
    roles: ['SUPER_ADMIN', 'CLINIC_ADMIN'],
    permission: {
      name: 'GENERATE_REPORTS',
      role: 'CLINIC_ADMIN',
    },
  },
  // Backend is not ready
  // {
  //   title: 'sidebar.reportPatient',
  //   route: 'ReportPatient',
  //   icon: '$note-health',
  //   roles: ['SUPER_ADMIN'],
  // },
  {
    title: 'sidebar.rpm_inventory',
    route: 'Inventory',
    icon: '$inventory',
    roles: ['CLINIC_ADMIN'],
    permission: {
      name: 'MANAGE_INVENTORY',
      role: 'CLINIC_ADMIN',
    },
  },
  {
    title: 'sidebar.rpmEnrollment',
    route: 'Enrollment',
    icon: '$inventory',
    roles: ['CLINIC_ADMIN'],
    permission: {
      name: 'ASSIGN_PATIENT_RPM',
      role: 'CLINIC_ADMIN',
    },
  },
  {
    title: 'sidebar.rpmOrders',
    route: 'Orders',
    icon: '$inventory',
    roles: ['CLINIC_ADMIN'],
    permission: {
      name: 'MANAGE_ORDERS',
      role: 'CLINIC_ADMIN',
    },
  },
  {
    title: 'sidebar.rpmMonitoring',
    route: 'Monitoring',
    icon: '$inventory',
    roles: ['CLINIC_ADMIN'],
    permission: {
      name: 'MANAGE_RPM',
      role: 'CLINIC_ADMIN',
    },
  },
  {
    roles: ['DIVIDER'],
  },
  {
    title: 'sidebar.sftp',
    route: 'SftpFtpUsers',
    icon: '$gcp',
    roles: ['SUPER_ADMIN'],
  },
  {
    title: 'sidebar.settings',
    route: 'Settings',
    icon: '$settings',
    roles: ['SUPER_ADMIN', 'CLINIC_ADMIN'],
  },
  {
    title: 'sidebar.dataImport',
    route: 'DataImport',
    icon: '$note',
    roles: ['CLINIC_ADMIN'],
    permission: {
      name: 'UPLOAD_CSV',
      role: 'CLINIC_ADMIN',
    },
  },
  {
    title: 'sidebar.support',
    route: 'Support',
    icon: '$information',
    roles: ['CLINIC_ADMIN'],
  },
];

export function getSidebarMenuList(account) {
  if (!account || !Vue.prototype.$accountHasPermission) return;

  const menu = sidebarLinks.filter(route => {
    const isAvailableRoute = availableRoutes[account.role].find(r => r.name === route.route);
    let hasPermission = true;
    if (route.permission && account.role === route.permission.role) {
      hasPermission = Vue.prototype.$accountHasPermission(permissions[route.permission.name]);
    }

    return isAvailableRoute && hasPermission;
  });
  store.commit('common/setSidebarMenuList', menu);
}
